import React from 'react'
import { Card, Col, Row } from 'react-bootstrap'
import SliderPlugin from './SliderPlugin/SliderPlugin'

const FoodModeling = () => {
  return (
    <>
      <Card className='food-modeling-container no-border rounded-0 container'>
        <Card.Body>
            <Card.Title className='food-modeling-title py-1'> 食品サンプルのモデリング </Card.Title>
            <Card.Text className='food-modeling-text py-1 text-left'>
            料理も同様です。フードスタイリストを雇うのはお金がかかるし、探すのも大変です。その点、デジタルのフードモックアップは、写真と同じくらい魅力的な仕上がりになりますし、各要素の配置を、ゴマ一粒に至るまで自由にコントロールすることができます。料理の写真の置き換えは、ウェブサイト、メニュー、広告、店内サインなど、さまざまな用途で使用できます。実際に、3Dフードモデルを使ってメニューのARプレビューを行い、お客様やお食事される方に見ていただくことで、売上や満足度の向上に繋がっています。
            </Card.Text>
        </Card.Body>
        <Row className='food-renderer-box'>
            <Col sm={6} md={5}>
                <Card className='no-border rounded-0'>
                    <Card.Body>
                        <Card.Title className='food-modeling-render-title'> ・ハンバーガーの3Dレンダリング </Card.Title>
                            <div className='burger-section'>
                                <video className='burger-player' autoPlay muted loop playsInline onContextMenu={(e) => e.preventDefault()}>
                                    <source src={"/assets/food/burger/Burger_Render.mp4"} type="video/mp4"/>
                                </video>
                            </div>
                    </Card.Body>
                </Card>
            </Col>
            <Col sm={6} md={7}>
                <Card className='no-border rounded-0'>
                    <Card.Body>
                        <Card.Title className='food-modeling-render-title'> ・ピザの3Dレンダリング </Card.Title>
                        <div className="pizza-section ">
                            <SliderPlugin data={1} />
                        </div>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
      </Card>
    </>
  )
}

export default FoodModeling
